import React from 'react';
import { Button, Box, Typography } from '@mui/material';
import { GetApp as InstallIcon } from '@mui/icons-material';
import { useInstallPrompt } from '../hooks/useInstallPrompt';

const InstallButton = () => {
  const { isInstallable, promptInstall } = useInstallPrompt();

  const handleInstallClick = async () => {
    const accepted = await promptInstall();
    if (accepted) {
      console.log('User accepted the install prompt');
    } else {
      console.log('User dismissed the install prompt');
    }
  };

  if (!isInstallable) {
    return null;
  }

  return (
    <Button
      variant="outlined"
      color="primary"
      size="small"
      startIcon={<InstallIcon />}
      onClick={handleInstallClick}
      sx={{ 
        color: 'white',
        borderColor: 'rgba(255,255,255,0.5)',
        '&:hover': {
          borderColor: 'white',
          backgroundColor: 'rgba(255,255,255,0.1)'
        }
      }}
    >
      התקן אפליקציה
    </Button>
  );
};

export default InstallButton;
